import React from 'react';

const SingleChoose = (props) => {
  const { itemClass, icon, title, description } = props;
  return (
    <div
      className={
        itemClass
          ? itemClass
          : 'it-choose-staff style-1 d-flex align-items-center'
      }
    >
      <div className="it-choose-staff-icon">
        <span>
          <i className={icon ? icon : 'flaticon-doctor'}></i>
        </span>
      </div>
      <div className="it-choose-staff-text">
        <h6 className="it-choose-staff-title">
          {title ? title : 'Qualified Doctors'}
        </h6>
        <p className="mb-0">
          {description
            ? description
            : 'Duis aute irure reprehenderit in voluptate velit.'}
        </p>
      </div>
    </div>
  );
};

export default SingleChoose;
